export default __webpack_public_path__ + "static/media/the-last-martian.ffdd5954.jpeg";